import React from 'react';

/**
 * Guarda de gesto para o fundo escuro de um modal.
 *
 * O "clique fora fecha" tem uma armadilha: quando o mousedown acontece dentro de
 * um campo e o mouseup cai no fundo — o que é banal ao selecionar um texto para
 * corrigir uma palavra — o navegador dispara o `click` no ancestral comum, que é o
 * próprio fundo. `e.target === e.currentTarget` fica verdadeiro e o modal fecha,
 * levando junto o que já tinha sido preenchido. O `stopPropagation` do card não
 * protege, porque o evento nasce no fundo em vez de subir de dentro.
 *
 * Aqui só conta como clique fora quando o mousedown E o clique aconteceram no
 * próprio fundo. Uso:
 *
 * ```tsx
 * <div className="fixed inset-0 ..." {...propsFundoModal(onClose)}>
 * ```
 *
 * O estado do gesto fica num WeakSet chaveado pelo elemento do fundo — cada modal
 * tem o seu, então modais empilhados não interferem um no outro, e não há hook
 * envolvido (estes fundos costumam ser renderizados depois de um
 * `if (!isOpen) return null`, onde um hook quebraria a ordem de renderização).
 */
const gestosNoFundo = new WeakSet<EventTarget>();

export function propsFundoModal(aoFechar: () => void) {
    return {
        onMouseDown: (e: React.MouseEvent) => {
            if (e.target === e.currentTarget) gestosNoFundo.add(e.currentTarget);
            else gestosNoFundo.delete(e.currentTarget);
        },
        onClick: (e: React.MouseEvent) => {
            const comecouNoFundo = gestosNoFundo.has(e.currentTarget);
            gestosNoFundo.delete(e.currentTarget);
            if (comecouNoFundo && e.target === e.currentTarget) aoFechar();
        },
    };
}

export default propsFundoModal;
